import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import RaytechLogo from "@/components/brand/RaytechLogo";

const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="border-t border-brand-border bg-brand-ink text-white" data-testid="site-footer">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <RaytechLogo size={36} variant="light" />
            <span className="font-heading font-bold tracking-tight text-lg leading-none">
              RAYTECH
              <span className="block text-[10px] tracking-[0.32em] font-medium text-brand-sky mt-1">
                ADVISORY
              </span>
            </span>
          </div>
          <p className="mt-5 text-white/70 max-w-sm leading-relaxed">
            {t.footer.tagline}
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="overline !text-white/60">{t.footer.nav}</h4>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/" className="hover:text-brand-sky transition-colors" data-testid="footer-link-home">{t.nav.home}</Link></li>
            <li><Link to="/services" className="hover:text-brand-sky transition-colors" data-testid="footer-link-services">{t.nav.services}</Link></li>
            <li><Link to="/about" className="hover:text-brand-sky transition-colors" data-testid="footer-link-about">{t.nav.about}</Link></li>
            <li><Link to="/contact" className="hover:text-brand-sky transition-colors" data-testid="footer-link-contact">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="overline !text-white/60">{t.contact.info_title}</h4>
          <ul className="mt-5 space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-3"><Mail size={16} className="mt-0.5 text-brand-sky" /><a href={`mailto:${t.contact.info_email}`} className="hover:text-white transition-colors" data-testid="footer-email">{t.contact.info_email}</a></li>
            <li className="flex items-start gap-3"><Phone size={16} className="mt-0.5 text-brand-sky" /><a href={`tel:${t.contact.info_phone_raw}`} className="hover:text-white transition-colors" data-testid="footer-phone">{t.contact.info_phone}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-brand-sky" />{t.contact.info_location}</li>
            <li className="flex items-start gap-3"><Clock size={16} className="mt-0.5 text-brand-sky" />{t.contact.info_hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} RAYTECH Advisory. {t.footer.rights}</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white">{t.footer.legal_mentions}</a>
            <a href="#" className="hover:text-white">{t.footer.privacy}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
